export const ModuleEmits = {
    confirm: (_data?: any) => true,
    cancel: (_data?: any) => true,
};

export const ModulePropsOption = {
    name: { type: String },
    width: { type: [Number, String] as PropType<number | string>, default: 496 },
    height: { type: [Number, String] as PropType<number | string>, default: "auto" },
    spacing: { type: String, default: "40px 56px 48px" },
    content: { type: String },
    controls: { type: Boolean, default: true },
} as const;
